"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.georgiaTranslations = void 0;
var _types = require("../../../types");
const georgiaTranslations = exports.georgiaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'ბოდიშს გიხდით!',
  [_types.ErrorPageTranslationKey.buttonText]: 'უკან',
  [_types.ErrorPageTranslationKey.text]: 'მოცემულ მომენტში ეს გვერდი მიუწვდომელია',
  [_types.ErrorPageTranslationKey.notFound]: 'სამწუხაროდ, თქვენს მიერ მითითებული მისამართი მიუწვდომელია ',
  [_types.ErrorPageTranslationKey.unauthorized]: 'გვერდი, რომელზეც ცდილობთ შესვლას, შეზღუდულია და ყველა კრიტერიუმი არ დაკმაყოფილდა.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'გთხოვთ დაუკავშირდეთ ორიფლეიმის მხარდაჭერის ჯგუფს ელექტრონული ფოსტით:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'მოთხოვნილი URL უარყოფილია!'
};
